import { ProfilePhoto } from 'components/ideal-core-ui'
import s from './PhotoCellRenderer.scss'

const PhotoCellRenderer = ({ data }) => {
  if (!data) return null
  return <ProfilePhoto src={data.photo} className={s.photo} />
}

export default PhotoCellRenderer
